<div class="white-box main-black mt-4 p-4 border-radius">
	<div>
		<h4>{{ 'iotemeter_site_energy_report.consumption_charts' | translate }}</h4>
	</div>

	<div class="d-flex flex-wrap justify-content-between py-4">
		<div class="row align-items-end w-100 mx-0 py-4">
			<!-- select year -->
			<div class="col-lg-4 col-md-6 col-12 mb-2">
				<label class="mr-2">{{'g.select_year' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="yearList"
					bindLabel="label"
					bindValue="id"
					placeholder="{{'g.select_year' | translate}}"
					name="year"
					[(ngModel)]="selectedYear"
					[clearable]="false"
					(change)="getIotemeterEnergyConsumption()"
				></ng-select>
			</div>

			<!-- select period type -->
			<div class="col-lg-4 col-md-6 col-12 mb-2" *ngIf="selectedYear != allYearsId">
				<label class="mr-2">{{'site.select_period_type' | translate}}</label>
				<ng-select
					[items]="periodTypes"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'site.select_period_type' | translate}}"
					name="period_type"
					[(ngModel)]="selectedPeriodType"
					[clearable]="false"
					(change)="getIotemeterEnergyConsumption()"
				></ng-select>
			</div>

			<!-- select Device Type -->
			<div class="col-lg-3 col-md-6 col-12 mb-2" *ngIf="!device">
				<label class="mr-2">{{'iotemeter_site_energy_report.select_meter_type' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="devicesList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'iotemeter_site_energy_report.select_meter_type' | translate}}"
					name="device_type"
					[(ngModel)]="selectedDeviceType"
					[clearable]="false"
					(ngModelChange)="getIotemeterEnergyConsumption()"
				></ng-select>
			</div>
			<div class="col-auto ml-auto mb-2 d-flex align-items-end" *ngIf="chartsData.consumed_energy.length">
				<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
			</div>
		</div>
	</div>

	<!-- table -->
	<div class="col-12" *ngIf="chartsData.consumed_energy.length; else noData">
		<div class="row">
			<sct-charts
				id="energy_consumption_chart"
				title="{{'iotemeter_site_energy_report.energy_consumption_chart' | translate}}"
				[data]="chartsData.consumed_energy"
				[columnNames]="chartColumns.consumed_energy"
				[options]="consumedChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row">
			<sct-charts
				id="power_demand_chart"
				title="{{'iotemeter_site_energy_report.power_demand_chart' | translate}}"
				[data]="chartsData.demand_energy"
				[columnNames]="chartColumns.demand_energy"
				[options]="demandChartConfig"
				[type]="'LineChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>

</div>

<ng-template #noData class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
